import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const REMOTE_SUITABILITY_SELECTIONS = [
  { value: '0', label: 'Very Low' },
  { value: '1', label: 'Low' },
  { value: '2', label: 'Medium' },
  { value: '3', label: 'High' },
  { value: '4', label: 'Very High' },
];

export const remoteSuitabilityDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.REMOTE_SUITABILITY,
  name: 'Remote Suitability',
  type: FilterType.STATIC_LIST,
  selections: [],
  isVisible: true,
};

export const remoteSuitabilityHandler: FilterHandler<StaticListFilter> = {
  isActive(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: StaticListFilter) {
    return { ...currentFilterState };
  },
};
